import { render, staticRenderFns } from "./TaskStatusSection.vue?vue&type=template&id=6fd13e2b&"
import script from "./TaskStatusSection.vue?vue&type=script&lang=js&"
export * from "./TaskStatusSection.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports